import React from 'react';
import ReportForm from '../ReportForm/ReportForm';

/** Reads one report back, with every input disabled. */
const ReadReport = () => <ReportForm mode="view" />;

export default ReadReport;
